
import * as ELIconModules from "@element-plus/icons-vue";

export function LoadIcons(app:any){
    for(const [key,val] of Object.entries(ELIconModules)){
        app.component(key,val);
    }
}
